import { useLocalStorage } from '@vueuse/core';

import {
  isImpactfulQuizQuestion,
  OnsiteOfferQuizConfig,
  questions,
  QuizResults,
} from '@/data/quiz/onsiteOffer';
import { setCookie } from '@/utils/isomorphic/cookie';

export function useOnsiteOffer() {
  const config = useLocalStorage<OnsiteOfferQuizConfig>('onsiteOfferQuiz.config', {
    isOpen: false,
  });

  const results = useLocalStorage<QuizResults>('onsiteOfferQuiz.results', () => {
    const [firstQuestion, secondQuestion] = questions.filter(isImpactfulQuizQuestion);
    return {
      selections: [firstQuestion, secondQuestion],
    };
  });

  function closeModal() {
    config.value.isOpen = false;
  }

  function openOnsiteOffer(initialScreen: OnsiteOfferQuizConfig['initialScreen']) {
    config.value.initialScreen = initialScreen;
    config.value.isOpen = true;
  }

  function rescindOffer() {
    closeModal();

    setCookie('dy_onsite_offer_quiz_v3_success', 'true');

    if (config.value.initialScreen?.stickyBubbleSelector) {
      document
        .querySelector(config.value.initialScreen.stickyBubbleSelector)
        ?.classList.add('hidden');
    }
  }

  return {
    closeModal,
    config,
    openOnsiteOffer,
    rescindOffer,
    results,
  };
}
